module.exports = __webpack_public_path__ + "static/media/si.4279aabf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/si.svg
// module id = 1155
// module chunks = 0